import Tasks from "../components/tasks/Tasks";
import Account from "../pages/account/Account";

export default [
  {
    path: "/",
    page: Tasks,
  },
  {
    path: "/account",
    page: Account,
  }
];
